<template>
    <div>
      <div class="card-block">
        <div class="form-group row">
          <div class="col-md-10 pb-2">
            <h5>
              <strong>
                <i class="fas fa-users"></i> Pessoas no Grupo Econômico
              </strong>
            </h5>
          </div>
          <div class="col-md-2">
            <a
              v-if="!isBusyGrupoEconomico"
              href="javascript:void(0);"
              @click="toggleBusyGrupoEconomico"
            >
              <i
                class="fas fa-eye-slash"
                style="font-size: 16px"
                v-b-tooltip.hover
                :title="'Minimizar Dados'"
              ></i>
            </a>
            <a
              v-else
              href="javascript:void(0);"
              @click="toggleBusyGrupoEconomico"
            >
              <i
                class="fas fa-eye"
                style="font-size: 16px"
                v-b-tooltip.hover
                :title="'Mostrar Dados'"
              ></i>
            </a>
          </div>
        </div>

        <div
          class="table-responsive pt-2 pl-3 pr-3"
          v-show="!isBusyGrupoEconomico"
        >
          <table class="table table-hover" style="border: 1px solid #dcdede">
            <thead
              class="thead-third"
              style="border: solid 1px #04a791; font-size: 12px"
            >
              <tr>
                <th class="text-center">NOME</th>
                <th class="text-center">GRUPO ECONÔMICO</th>
                <th class="text-center">CÓD. GRUPO ECONÔMICO</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(obj, index) in pessoaGrupoEconomicoList"
                :key="index"
                style="font-size: 11px"
              >
                <TableColumn
                  :IsText="true"
                  :status="1"
                  :value="obj.nomeCliente"
                  @Edit="openAssociatePage(obj.associadoId)"
                />
                <TableColumn
                  :IsText="true"
                  :status="1"
                  :value="obj.descricaoGrupoEconomico"
                  @Edit="openAssociatePage(obj.associadoId)"
                />
                <TableColumn
                  :IsText="true"
                  :status="1"
                  :value="obj.codigoGrupoEconomico.toString()"
                  @Edit="openAssociatePage(obj.associadoId)"
                />
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </template>

<script>
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import TableColumn from '../../../../components/forms/TableColumn.vue'

export default {
  name: 'AssociateGrupoEco',
  components: {
    AssociateRepository,
    TableColumn
  },
  props: {
    pessoaGrupoEconomicoList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      isBusyGrupoEconomico: true
    }
  },
  methods: {
    toggleBusyGrupoEconomico () {
      this.isBusyGrupoEconomico = !this.isBusyGrupoEconomico
    },
    openAssociatePage (associateId) {
      this.$router.replace({
        name: 'AssociatePage',
        params: {
          associateId: associateId,
          backUrl: 'Associate'
        }
      })
      this.$router.go()
    }
  }
}
</script>

  <style scoped>
  </style>



// WEBPACK FOOTER //
// src/views/private/associate/components/AssociateGrupoEco.vue